import { render, staticRenderFns } from "./ShoplistCategoryHeader.vue?vue&type=template&id=390ca0ac&"
import script from "./ShoplistCategoryHeader.vue?vue&type=script&lang=js&"
export * from "./ShoplistCategoryHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390ca0ac')) {
      api.createRecord('390ca0ac', component.options)
    } else {
      api.reload('390ca0ac', component.options)
    }
    module.hot.accept("./ShoplistCategoryHeader.vue?vue&type=template&id=390ca0ac&", function () {
      api.rerender('390ca0ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ShoplistCategoryHeader.vue"
export default component.exports